import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { styled } from "@mui/material/styles";
import { black } from "designSystem/styles/color";
import { Box, Grid, IconButton, Text } from "designSystem/index";
import { hoverStyle } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

const PREFIX = "Design";

const classes = {
	hover: `${PREFIX}hover`,
};

const StyledCssColumnGrid = styled(CssColumnGrid)(({
	theme,
}) => ({
	[`& .${classes.hover}`]: {
		...hoverStyle(theme),

		"& .MuiGrid-item": {
			alignItems: "center",
			display: "flex",
		},
	},
}));

export default () => {
	const { hover } = classes;

	return (
		<StyledCssColumnGrid columns={9}>
			<Text semiBold text="darkMode" />
			<Text semiBold text="default" />
			<Text semiBold text="defaultOnGrey" />
			<Text semiBold text="iconOnly" />
			<Text semiBold text="iconOnlyOnGrey" />
			<Text semiBold text="inactive" />
			<Text semiBold text="primary" />
			<Text semiBold text="secondary" />
			<Text semiBold text="outline" />
			<Box
				bgcolor={black[50]}
				height={25}
				margin="auto"
				width={25}
			>
				<IconButton design="darkMode" size="large">
					<AllInclusiveIcon />
				</IconButton>
			</Box>
			<IconButton design="default" size="large">
				<AllInclusiveIcon />
			</IconButton>
			<Grid
				className={hover}
				container
				spacing={1}
				wrap="nowrap"
			>
				<Grid item>
					<Text noWrap text="Item with hover" />
				</Grid>
				<Grid item>
					<IconButton design="defaultOnGrey" size="large">
						<AllInclusiveIcon />
					</IconButton>
				</Grid>
			</Grid>
			<IconButton design="iconOnly" size="large">
				<AllInclusiveIcon />
			</IconButton>
			<Grid
				className={hover}
				container
				spacing={1}
				wrap="nowrap"
			>
				<Grid item>
					<Text noWrap text="Item with hover" />
				</Grid>
				<Grid item>
					<IconButton design="iconOnlyOnGrey" size="large">
						<AllInclusiveIcon />
					</IconButton>
				</Grid>
			</Grid>
			<IconButton design="inactive" size="large">
				<AllInclusiveIcon />
			</IconButton>
			<IconButton design="primary" size="large">
				<AllInclusiveIcon />
			</IconButton>
			<IconButton design="secondary" size="large">
				<AllInclusiveIcon />
			</IconButton>
			<IconButton design="outline" size="large">
				<AllInclusiveIcon />
			</IconButton>
		</StyledCssColumnGrid>
	);
};